notifications.controller('DeviceHistoryListController', ['$scope', 'deviceHistoryService', function ($scope, deviceHistoryService) {
    var self = this;

    $scope.listName = 'DeviceHistoryList';

    deviceHistoryService.scope = $scope;
    $scope.gridOptions = deviceHistoryService.getGridOptions();

    deviceHistoryService.getPage();
}]);